import { WorkflowStatusName } from "../items";

// WF状態の検索条件
export class WorkflowStatusSearchCondition {
  public isSelected: boolean;
  public status: WorkflowStatusName;

  getSummary(): string {
    return this.isSelected ? this.status.name : "";
  }

  clone(): WorkflowStatusSearchCondition {
    const newObj = new WorkflowStatusSearchCondition();
    newObj.isSelected = this.isSelected;
    newObj.status = this.status ? this.status.clone() : null;

    return newObj;
  }
}
